<template>
  <div>
    <div class="modal-form-coluna">
      <div>
        <h3>UF <span>*</span></h3>
        <div class="cenario-cnpj">
          <CenarioInput
            placeholder="Selecione uma UF"
            :model="uf"
            :options="filtros.estado_origem.valores.map(p => p.label)"
            @update:model="update => (uf = update)"
            @selected="
              update =>
                calculaForm(
                  update == ''
                    ? ''
                    : filtros.estado_origem.valores.find(f => f.label == update).value,
                  'uf'
                )
            "
            maxHeight="200"
            nome="uf"
            :validaCampos="camposRequeridos"
            :exibeValidacao="exibeValidacao"
          />
        </div>
      </div>
      <div>
        <h3>REGIME TRIBUTÁRIO <span>*</span></h3>
        <div>
          <CenarioInput
            placeholder="Selecione um Regime Tributário"
            :model="regime"
            :options="
              filtros.regime_tributacao.valores
                .filter(f => ['30', '31', '32'].includes(f.value))
                .map(p => p.label)
            "
            @update:model="update => (regime = update)"
            @selected="
              update =>
                calculaForm(
                  update == ''
                    ? ''
                    : filtros.regime_tributacao.valores.find(f => f.label == update).value,
                  'regime'
                )
            "
            nome="regime"
            :validaCampos="camposRequeridos"
            :exibeValidacao="exibeValidacao"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filtros from "@/store/modules/cenarioFiltros.js";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalEmpresaTerceiraLinha",
  components: {
    BotaoPadrao,
    CenarioInput
  },
  props: {
    calculaForm: Function,
    camposRequeridos: Object,
    exibeValidacao: Boolean,
    form: Object
  },

  data() {
    return {
      filtros,
      regime: "",
      uf: ""
    };
  },
  created() {
    this.uf = this.form.uf;
    this.regime = this.form.regime;
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.uf =
          this.form.uf == "0" || this.form.uf == ""
            ? ""
            : this.filtros.estado_origem.valores.find(f => f.value == this.form.uf).label;
        this.regime =
          this.form.regime == "0" || this.form.regime == ""
            ? ""
            : this.filtros.regime_tributacao.valores.find(f => f.value == this.form.regime).label;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}

.cenario-cnpj {
  display: flex;
}
.modal-form-coluna {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
